// TODO - remove lint disable when editing this file
/* eslint-disable */
import AtomicBaseConverter from './AtomicBaseConverter'

export default class ReferenceConverter extends AtomicBaseConverter {
  constructor() {
    super('reference', ['atomic-ellipsis.reference'])
  }

  appendAndGetBlocks(element, context) {
    // Treatment for oembed reference which failed to denormalize or url is not yet defined
    if (element.referent && element.referent.service === 'oembed') {
      return context.appendAtomicBlock({
        ...element,
        type: 'oembed_response',
      })
    }
    return super.appendAndGetBlocks(element, context)
  }
}
